<palantir-dialog title="SUPER DEBUG - Permissões">
  <palantir-dialog-content class="palantir-scrollbar flex flex-col gap-4">
    <palantir-text type="title">Permissões</palantir-text>

    @for (
      parentPermission of permissions();
      track parentPermission.id;
      let isFirst = $first;
      let isLast = $last
    ) {
      <div class="rounded-lg border border-neutral-200 bg-white">
        <table class="w-full border-collapse">
          <tr>
            <td class="w-full border-b border-neutral-300 p-5">
              <palantir-text type="subtitle">
                {{ parentPermission.title }} ({{ parentPermission.children.length }})
              </palantir-text>
            </td>

            <td class="min-w-[40px] border-b border-neutral-300 p-5 pb-4 text-center">
              <palantir-checkbox
                (click)="toggleAll(parentPermission)"
                [attr.aria-selected]="isAllChecked(parentPermission)"
                [attr.indeterminate]="isSomeChecked(parentPermission)"
              ></palantir-checkbox>
            </td>
          </tr>

          @for (
            childPermission of parentPermission.children;
            track childPermission.id;
            let isFirst = $first;
            let isLast = $last
          ) {
            <tr>
              <td
                class="w-full px-5 py-3"
                [ngClass]="{
                  'pt-5': isFirst,
                  'pb-5': isLast,
                }"
              >
                <palantir-text type="text">{{ childPermission.title }}</palantir-text>
              </td>

              <td
                class="min-w-[40px] px-5 py-3 pb-2 text-center"
                [ngClass]="{
                  'pt-5': isFirst,
                  'pb-4': isLast,
                }"
              >
                <palantir-checkbox
                  (click)="togglePermission(childPermission)"
                  [attr.aria-selected]="isSelected(childPermission)"
                ></palantir-checkbox>
              </td>
            </tr>
          }
        </table>
      </div>
    }
  </palantir-dialog-content>
</palantir-dialog>
